"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _createStyles = _interopRequireDefault(require("../createStyles"));

var _colors = require("../theme/colors");

var _excluded = ["color", "className"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _createStyles["default"])({
  root: {
    position: 'absolute',
    overflow: 'hidden',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    '& span': {
      transform: 'scale(0)',
      borderRadius: '100%',
      position: 'absolute',
      overflow: 'hidden',
      opacity: 0.5,
      backgroundColor: function backgroundColor(_ref) {
        var color = _ref.color;
        return color;
      },
      animation: '$rippleEffect 850ms'
    }
  },
  '@keyframes rippleEffect': {
    to: {
      opacity: 0,
      transform: 'scale(2)'
    }
  }
});

var TouchRipple = /*#__PURE__*/_react["default"].forwardRef(function TouchRipple(_ref2, ref) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? _colors.white : _ref2$color,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);

  var _useState = (0, _react.useState)({}),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      spanStyles = _useState2[0],
      setSpanStyles = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      count = _useState4[0],
      setCount = _useState4[1];

  var classes = useStyles({
    color: color
  });
  var showRipple = (0, _react.useCallback)(function (e) {
    var rippleContainer = e.currentTarget;
    var size = rippleContainer.offsetWidth;
    var pos = rippleContainer.getBoundingClientRect();
    var x = Math.round(e.clientX - pos.left);
    var y = Math.round(e.clientY - pos.top);
    setCount(count + 1);
    setSpanStyles((0, _extends3["default"])({}, spanStyles, (0, _defineProperty2["default"])({}, count, {
      top: -(size / 2) + y,
      left: -(size / 2) + x,
      height: size,
      width: size
    })));
  }, [count, spanStyles]);
  var cleanUp = (0, _react.useCallback)((0, _debounce["default"])(function () {
    setCount(0);
    setSpanStyles({});
  }, 2500), []);

  _react["default"].useImperativeHandle(ref, function () {
    return {
      ripple: showRipple,
      stop: cleanUp
    };
  });

  (0, _react.useEffect)(function () {
    return function () {
      return cleanUp.cancel();
    };
  }, [cleanUp]);
  var spanArray = (0, _react.useMemo)(function () {
    return Object.keys(spanStyles);
  }, [spanStyles]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    role: "presentation",
    className: (0, _classnames["default"])(classes.root, className)
  }, !(0, _isEmpty["default"])(spanArray) ? spanArray.map(function (key) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: "rippleWave".concat(key),
      style: (0, _extends3["default"])({}, spanStyles[key])
    });
  }) : null);
});

var _default = TouchRipple;
exports["default"] = _default;